const permisosmicrositios = {
    BuscarUsuarios:"SICPO/Permisos/BuscarUsuarios",
    GuardarPermisosUsuario:"SICPO/Permisos/GuardarPermisos",
    ObtenerPermisos:"SICPO/Permisos/ObtenerPermisos",
    GuardarPermisosSICPO: "SICPO/Permisos/GuardarPermisosSICPO",
    ObtenerFuncionesMicrositios:"SICPO/Permisos/ObtenerFuncioneMicrositios"



}
export default permisosmicrositios;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPO/sistema/micrositioweb/permisosmicrositios/permisosmicrositios.js
// module id = null
// module chunks = 